<template>
    <v-app>
        <router-view />
        <v-snackbar v-model="showSnackBar.state" center :timeout="showSnackBar.timeout || 3000" top right :color="showSnackBar.color" @input="onSnackbarInput">{{
            showSnackBar.text
        }}</v-snackbar>

        <v-dialog v-model="openModalDefault.state" hide-overlay persistent width="200">
            <v-card color="green" dark>
                <v-card-text>
                    {{ openModalDefault.text }}
                    <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
                </v-card-text>
                <v-card-actions v-if="openModalDefault.close">
                    <v-spacer></v-spacer>
                    <v-btn dark text @click="closeModal"> CERRAR </v-btn> <v-spacer></v-spacer>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-app>
</template>

<script>
import { mapState } from 'vuex'

import { sleep } from '@/utils/genericUtils'
import { BUSINESS_DOMAINS, DEFAULT_BUSINESS } from '@/config/business'

export default {
    name: 'App',
    computed: {
        ...mapState('mainUI', ['showSnackBar', 'openModalDefault']),
        ...mapState('users', ['user'])
    },
    methods: {
        closeModal() {
            this.$store.commit('mainUI/OPEN_MODAL', { state: false })
        },
        onSnackbarInput(val) {
            if (!val) {
                this.$store.commit('mainUI/OPEN_BAR', { state: false })
            }
        }
    },
    watch: {
        async openModalDefault(v) {
            console.log('vvvv ', v)
            if (v['isTimeout']) {
                await sleep(2500)
                this.$store.commit('mainUI/OPEN_MODAL', { state: false })
            }
        }
    },
    async created() {
        //console.log('user ', this.user)
        this.$store.commit('mainUI/OPEN_BAR', { state: false })
        this.$store.commit('mainUI/OPEN_MODAL', { state: false })
        const hostname = location.hostname === 'localhost' ? BUSINESS_DOMAINS[DEFAULT_BUSINESS] : location.hostname
        const domain = hostname.startsWith('intranet.') ? hostname.slice(9) : hostname
        await this.$store.dispatch('bussines/getBussines', JSON.stringify(domain))
    }
}
</script>
<style lang="css">
.required label::after {
    content: '*';
}
</style>
